import { render, staticRenderFns } from "./DashboardUserInfo.vue?vue&type=template&id=8d8aea1c&scoped=true&"
import script from "./DashboardUserInfo.vue?vue&type=script&lang=js&"
export * from "./DashboardUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserInfo.vue?vue&type=style&index=0&id=8d8aea1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8aea1c",
  null
  
)

export default component.exports